export default __webpack_public_path__ + "static/media/s4_male.fdbbfc5e.wav";